import moment from 'moment';
import { getDtd, getFareType } from '../../../../utilities/helpers';
import { sendAncillaryAddToCartEvent } from '../../../../utilities/customer-io-ancillary-events';

export default ({
  currency,
  isActiveFlowCorporate,
  noOfPassengersToBuyInsurance,
  options,
  pnrModel,
  userCorporate,
  userProfile }) => {
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrModel?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  let stopNumbers = 0;

  if (pnrModel?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrModel?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.forEach((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrModel?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);
  
  const inboundDepartureDate = pnrModel?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrModel?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  
  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}`;
  
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}`;
  }

  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const apItemRanges = [
    { min: 0, max: 2, range: '0 a 2' },
    { min: 3, max: 6, range: '3 a 6' },
    { min: 7, max: 13, range: '7 a 13' },
    { min: 14, max: 20, range: '14 a 20' },
    { min: 21, max: 27, range: '21 a 27' },
    { min: 28, max: 49, range: '28 a 49' },
    { min: 50, max: 89, range: '50 a 89' },
    { min: 90, max: 119, range: '90 a 119' },
    { min: 120, max: 149, range: '120 a 149' },
    { min: 150, max: Infinity, range: '150+' },
  ];
  
  const apItemRange = apItemRanges.find(({ min, max }) => apiItem >= min && apiItem <= max)?.range || 'NA';

  let msItem = 0;
  if (segments.length > 1) {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments.length - 1]?.arrivalDateTime);
    msItem = tripType !== 'MC' ? lastSegment.diff(firstSegment, 'days') : 0;
  }

  let marketSegment = [];
  const marketTest = [];
  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const tmpMarketSegmet = [];
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      tmpMarketSegmet.push(`${segmentsData?.departureAirport}${segmentsData?.arrivalAirport}`);
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    marketTest.push(tmpMarketSegmet.join('/'));
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  marketSegment = marketTest.join('-');
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');
    
  const travelerCollection = pnrModel?.cart?.travelerCollection || [];
  const ffNumber = `${userProfile?.ffNumber}`;
  let ffProgram = 'NA';
  travelerCollection.forEach(passenger => {
    if (passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });

  let adultMinors = 0;
  let adults = 0;
  let child = 0;
  let infants = 0;
  travelerCollection.forEach(traveler => {
    if (traveler?.paxType === 'ADULT') {
      const dateOfBirth = moment(traveler?.dateOfBirth).format('YYYYMMDD');
      const currentAge = moment().diff(moment(dateOfBirth, 'YYYYMMDD'), 'years');
      if (currentAge >= 15 && currentAge < 18) {
        adultMinors = adultMinors + 1;
      } else {
        adults = adults + 1;
      }
    } else if (traveler?.paxType === 'CHILD') {
      child = child + 1;
    } else if (traveler?.paxType === 'INFANT') {
      infants = infants + 1;
    }
  });

  const corpProgram = isActiveFlowCorporate ? 'AM Rewards Business' : 'NA';
  let corpId = 'NA';
  const companySelected = userCorporate?.companySelected;
  (userCorporate?.companies?.companies || []).forEach(company => {
    corpId = company?.companyName === companySelected ? company?.companyLoyaltyNumber : corpId;
  });

  if (pnrModel?.globalMarketFlight === 'DOMESTIC') {
    zone = 'DOM';
  } else {
    zone = 'INT';
  }

  function getAncillaryNameInsurance(insurance) {
    let newName = null;
    switch (insurance) {
      case 'AMS': newName = 'Basic Travel Insurance'; break;
      case 'SXC': newName = 'Cancellation Insurance'; break;
      case 'SXP': newName = 'Cancellation Insurance PLUS'; break;
      case 'SDE': newName = 'Luggage Insurance'; break;
      case 'SEP': newName = 'Luggage Insurance PLUS'; break;
      case 'SVI': newName = 'International Travel Insurance'; break;
      default: newName = null;
    }

    return newName;
  }

  const itemAffiliation = 'AM';
  const itemBrand = 'CHUBB';
  const itemCategory = 'Insurances';
  let itemCategory2 = 'NA';
  const itemCategory3 = 'NA';
  let price = 0;
  let quantity = 0;
  let totalPrice = 0;

  options.forEach((option) => {
    const type = option?.type ? option?.type : option?.ancillary?.type;
    const leg = option?.legCode;
    if (option?.quantity !== 0 && (type === 'AMS' || type === 'SEP' || type === 'SXP' || type === 'SDE' || type === 'SXC' || type === 'SVI')) {
      itemCategory2 = getAncillaryNameInsurance(type);
      price = option?.ancillary?.currency?.total;
      quantity = noOfPassengersToBuyInsurance[type];

      const segmentPrice = price * quantity;
      totalPrice += segmentPrice;

      legCollection.forEach((legs, legIndex) => {
        if (legs?.itineraryPartType === 'OUTBOUND' || legIndex === 0) {
          (legs?.segmentsCollection || []).forEach((passenger, index) => {
            if (index > 0) return;
            const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
            const flightTime = moment.utc(legs?.totalFlightTimeInMinutes * 60000).format('HH:mm');
            const opCarrier = passenger?.operatingCarrier;
            const brandFare = getFareType(passenger);
            let itemListName = 'NA';
            if (tripType === 'OW' || tripType === 'MC') {
              itemListName = 'Insurance outbound';
            } else {
              itemListName = 'Insurance outbound and insurance inbound';
            }
            if (leg === legs?.legCode) {
              const params = {
                'item_name': marketOd || 'NA',
                'coupon': 'NA',
                'discount': 0,
                'item_brand': itemBrand,
                'item_category': itemCategory,
                'item_category2': itemCategory2,
                'item_category3': itemCategory3,
                'item_list_name': itemListName,
                'item_affiliation': itemAffiliation,
                'price': price,
                'quantity': quantity || 0,
                'index': index,
                'market_ndod_item': marketNdod || 'NA',
                'market_od_item': marketOd || 'NA',
                'market_segment_item': marketSegment,
                'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
                'region_item': passenger?.regionKeyFromLeg || 'NA',
                'flight_time_dep': departureDateTime || 'NA',
                'flight_time': flightTime || 'NA',
                'branded_fare': brandFare,
                'upsell_amount': 0,
                'outbound_departure_date_item': outboundDepartureDate || 'NA',
                'inbound_departure_date_item': inboundDepartureDate,
                'fop_type_item': 'NA',
                'price_points': pnrModel?.cart?.points || 0,
                'airport_tax': pnrModel?.cart?.total?.taxDetails?.TUA || 0,
                'aircraft_type': passenger?.aircraftType || 'NA',
                'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
                'ap_item': apItemRange || 'NA',
                'ms_item': msItem || 'NA',
                'cabin_item': passenger?.cabin || 'NA',
                'class_item': passenger?.bookingClass || 'NA',
              };
              items.push(params);
            }
          });
        }
      });
    } 
  });

  const result = {
    event: 'add_to_cart',
    ecommerce: {
      'currency': currency || 'NA',
      'value': totalPrice,
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType || 'NA',
      'fop_type': 'Cash' || 'NA',
      'outbound_departure_date': outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone || 'NA',
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegment || 'NA',
      'region': legCollection?.[0].regionKey || 'NA',
      'value_points': pnrModel?.cart?.points || 0,
      'ffn_program': ffProgram,
      'ffn_id': ffNumber || 'NA',
      'corp_program': corpProgram,
      'corp_id': corpId || 'NA',
      'adults': adults,
      'childs': child,
      'infants': infants,
      'adult_minor': adultMinors,
      'stops_number': stopNumbers,
      'dtd': dtd || 'NA',
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': items,
    },
  };

  // Customer.io ancillary_addtocart event integration
  try {
    sendAncillaryAddToCartEvent({
      ancillaryType: 'travelinsurance',
      PNR: pnrModel?.pnrCode || 'Unknown',
      passengerName: pnrModel?.cart?.travelerCollection?.[0]?.firstName || '',
      passengerLastName: pnrModel?.cart?.travelerCollection?.[0]?.lastName || '',
      email: pnrModel?.cart?.travelerCollection?.[0]?.email || '',
      phone: pnrModel?.cart?.travelerCollection?.[0]?.phone || '',
      destination: legCollection?.[0]?.segmentsCollection?.[0]?.arrivalAirport || 'Unknown',
    });
  } catch (error) {
    // Silent error
  }


  return result;
};
